import { createActions, handleActions } from 'redux-actions'

// helpers
import { loadingError, startLoading, startSubmitting } from './_helpers'

export const CREATE_ATTENDANCE_PROOF_REVIEW = 'attendance/CREATE_ATTENDANCE_PROOF_REVIEW'
export const CREATE_ATTENDANCE_PROOF_REVIEW_FAILURE =
  'attendance/CREATE_ATTENDANCE_PROOF_REVIEW_FAILURE'
export const CREATE_ATTENDANCE_PROOF_REVIEW_SUCCESS =
  'attendance/CREATE_ATTENDANCE_PROOF_REVIEW_SUCCESS'

export const CREATE_PARTICIPANT_ATTENDANCE = 'attendance/CREATE_PARTICIPANT_ATTENDANCE'
export const CREATE_PARTICIPANT_ATTENDANCE_FAILURE =
  'attendance/CREATE_PARTICIPANT_ATTENDANCE_FAILURE'
export const CREATE_PARTICIPANT_ATTENDANCE_SUCCESS =
  'attendance/CREATE_PARTICIPANT_ATTENDANCE_SUCCESS'

export const FETCH_ATTENDANCE_PROOFS = 'attendance/FETCH_ATTENDANCE_PROOFS'
export const FETCH_ATTENDANCE_PROOFS_FAILURE = 'attendance/FETCH_ATTENDANCE_PROOFS_FAILURE'
export const FETCH_ATTENDANCE_PROOFS_SUCCESS = 'attendance/FETCH_ATTENDANCE_PROOFS_SUCCESS'

export const FETCH_PARTICIPANT_ATTENDANCE = 'attendance/FETCH_PARTICIPANT_ATTENDANCE'
export const FETCH_PARTICIPANT_ATTENDANCE_FAILURE =
  'attendance/FETCH_PARTICIPANT_ATTENDANCE_FAILURE'
export const FETCH_PARTICIPANT_ATTENDANCE_SUCCESS =
  'attendance/FETCH_PARTICIPANT_ATTENDANCE_SUCCESS'

export const FETCH_PARTICIPANT_ATTENDANCES = 'attendance/FETCH_PARTICIPANT_ATTENDANCES'
export const FETCH_PARTICIPANT_ATTENDANCES_FAILURE =
  'attendance/FETCH_PARTICIPANT_ATTENDANCES_FAILURE'
export const FETCH_PARTICIPANT_ATTENDANCES_SUCCESS =
  'attendance/FETCH_PARTICIPANT_ATTENDANCES_SUCCESS'

export const IMPORT_ATTENDANCES_PROOF = 'attendance/IMPORT_ATTENDANCES_PROOF'
export const IMPORT_ATTENDANCES_PROOF_FAILURE = 'attendance/IMPORT_ATTENDANCES_PROOF_FAILURE'
export const IMPORT_ATTENDANCES_PROOF_SUCCESS = 'attendance/IMPORT_ATTENDANCES_PROOF_SUCCESS'

export const IMPORT_PARTICIPANT_ATTENDANCES = 'attendance/IMPORT_PARTICIPANT_ATTENDANCES'
export const IMPORT_PARTICIPANT_ATTENDANCES_FAILURE =
  'attendance/IMPORT_PARTICIPANT_ATTENDANCES_FAILURE'
export const IMPORT_PARTICIPANT_ATTENDANCES_SUCCESS =
  'attendance/IMPORT_PARTICIPANT_ATTENDANCES_SUCCESS'

export const UPDATE_PARTICIPANT_ATTENDANCE = 'attendance/UPDATE_PARTICIPANT_ATTENDANCE'
export const UPDATE_PARTICIPANT_ATTENDANCE_FAILURE =
  'attendance/UPDATE_PARTICIPANT_ATTENDANCE_FAILURE'
export const UPDATE_PARTICIPANT_ATTENDANCE_SUCCESS =
  'attendance/UPDATE_PARTICIPANT_ATTENDANCE_SUCCESS'

export const {
  attendance: {
    createAttendanceProofReview,
    createAttendanceProofReviewSuccess,
    createAttendanceProofReviewFailure,
    createParticipantAttendance,
    createParticipantAttendanceSuccess,
    createParticipantAttendanceFailure,
    fetchAttendanceProofs,
    fetchAttendanceProofsSuccess,
    fetchAttendanceProofsFailure,
    fetchParticipantAttendance,
    fetchParticipantAttendanceSuccess,
    fetchParticipantAttendanceFailure,
    fetchParticipantAttendances,
    fetchParticipantAttendancesSuccess,
    fetchParticipantAttendancesFailure,
    importAttendancesProof,
    importAttendancesProofSuccess,
    importAttendancesProofFailure,
    importParticipantAttendances,
    importParticipantAttendancesSuccess,
    importParticipantAttendancesFailure,
    updateParticipantAttendance,
    updateParticipantAttendanceSuccess,
    updateParticipantAttendanceFailure
  }
} = createActions({
  [CREATE_ATTENDANCE_PROOF_REVIEW]: undefined,
  [CREATE_ATTENDANCE_PROOF_REVIEW_FAILURE]: undefined,
  [CREATE_ATTENDANCE_PROOF_REVIEW_SUCCESS]: undefined,
  [CREATE_PARTICIPANT_ATTENDANCE]: undefined,
  [CREATE_PARTICIPANT_ATTENDANCE_FAILURE]: undefined,
  [CREATE_PARTICIPANT_ATTENDANCE_SUCCESS]: undefined,
  [FETCH_ATTENDANCE_PROOFS]: undefined,
  [FETCH_ATTENDANCE_PROOFS_FAILURE]: undefined,
  [FETCH_ATTENDANCE_PROOFS_SUCCESS]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCE]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCE_FAILURE]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCE_SUCCESS]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCES]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCES_FAILURE]: undefined,
  [FETCH_PARTICIPANT_ATTENDANCES_SUCCESS]: undefined,
  [IMPORT_ATTENDANCES_PROOF]: undefined,
  [IMPORT_ATTENDANCES_PROOF_FAILURE]: undefined,
  [IMPORT_ATTENDANCES_PROOF_SUCCESS]: undefined,
  [IMPORT_PARTICIPANT_ATTENDANCES]: undefined,
  [IMPORT_PARTICIPANT_ATTENDANCES_FAILURE]: undefined,
  [IMPORT_PARTICIPANT_ATTENDANCES_SUCCESS]: undefined,
  [UPDATE_PARTICIPANT_ATTENDANCE]: undefined,
  [UPDATE_PARTICIPANT_ATTENDANCE_FAILURE]: undefined,
  [UPDATE_PARTICIPANT_ATTENDANCE_SUCCESS]: undefined
})

const initialState = {
  data: null,
  errorMessage: null,
  hasError: false,
  isLoading: false,
  isSubmitting: false,
  isSuccess: null,
  paginatedAttendancesData: { attendances: [], attendancesCount: 0, attendancesPageCount: 0 },
  paginatedAttendanceProofsData: {
    attendanceProofs: [],
    attendanceProofsCount: 0,
    attendanceProofsPageCount: 0
  }
}

export default handleActions(
  {
    [CREATE_ATTENDANCE_PROOF_REVIEW]: startSubmitting,
    [CREATE_ATTENDANCE_PROOF_REVIEW_FAILURE]: loadingError,
    [CREATE_ATTENDANCE_PROOF_REVIEW_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false
    }),
    [CREATE_PARTICIPANT_ATTENDANCE]: startSubmitting,
    [CREATE_PARTICIPANT_ATTENDANCE_FAILURE]: loadingError,
    [CREATE_PARTICIPANT_ATTENDANCE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false,
      data: {
        ...state.data,
        attendance: [...state.data.attendance, payload.data]
      }
    }),
    [FETCH_ATTENDANCE_PROOFS]: startLoading,
    [FETCH_ATTENDANCE_PROOFS_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [FETCH_ATTENDANCE_PROOFS_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedAttendanceProofsData.attendanceProofsPageCount = payload.pageCount || 0
      newState.paginatedAttendanceProofsData.attendanceProofsCount =
        payload.attendanceProofsCount || 0
      newState.paginatedAttendanceProofsData.attendanceProofs = payload.attendanceProofs || []

      return newState
    },
    [FETCH_PARTICIPANT_ATTENDANCE]: startLoading,
    [FETCH_PARTICIPANT_ATTENDANCE_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [FETCH_PARTICIPANT_ATTENDANCE_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      isSuccess: payload.forceRefresh ? true : null,
      hasError: false,
      data: payload.forceRefresh ? state.data : payload
    }),
    [FETCH_PARTICIPANT_ATTENDANCES]: startLoading,
    [FETCH_PARTICIPANT_ATTENDANCES_FAILURE]: (state, { payload }) => ({
      ...state,
      errorMessage: payload.message || 'An unknown error occurred',
      isLoading: false,
      isSuccess: false
    }),
    [FETCH_PARTICIPANT_ATTENDANCES_SUCCESS]: (state, { payload }) => {
      const newState = {
        ...state,
        isError: false,
        isLoading: false,
        hasSubmitted: false,
        isSuccess: true,
        errorMessage: null
      }

      newState.paginatedAttendancesData.attendancesPageCount = payload.pageCount || 0
      newState.paginatedAttendancesData.attendancesCount = payload.attendancesCount || 0
      newState.paginatedAttendancesData.attendances = payload.attendances || []

      return newState
    },
    [IMPORT_ATTENDANCES_PROOF]: startSubmitting,
    [IMPORT_ATTENDANCES_PROOF_FAILURE]: loadingError,
    [IMPORT_ATTENDANCES_PROOF_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false
    }),
    [IMPORT_PARTICIPANT_ATTENDANCES]: startSubmitting,
    [IMPORT_PARTICIPANT_ATTENDANCES_FAILURE]: loadingError,
    [IMPORT_PARTICIPANT_ATTENDANCES_SUCCESS]: state => ({
      ...state,
      isLoading: false,
      isSubmitting: false,
      hasSubmitted: true,
      isSuccess: true,
      hasError: false
    }),
    [UPDATE_PARTICIPANT_ATTENDANCE]: startSubmitting,
    [UPDATE_PARTICIPANT_ATTENDANCE_FAILURE]: loadingError,
    [UPDATE_PARTICIPANT_ATTENDANCE_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        hasSubmitted: true,
        isSuccess: true,
        hasError: false,
        data: {
          ...state.data,
          attendance: state.data.attendance.map(attendance => {
            if (attendance.id === payload.attendanceLogId) {
              return { ...attendance, ...payload.data }
            }
            return attendance
          })
        }
      }
    }
  },
  initialState
)
